import { IConfig } from "ngx-mask";

export const maskConfig: Partial<IConfig> = {
  validation: false,
};
